module.exports = __webpack_public_path__ + "static/media/eyeClose.739a57e2.svg";